import { render, staticRenderFns } from "./ShiftPage.vue?vue&type=template&id=ed69d88a&"
import script from "./ShiftPage.vue?vue&type=script&lang=js&"
export * from "./ShiftPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports